import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  updateTripItinerary,
} from 'redux/actions'

import Component from './component'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => (
  bindActionCreators(
    {
      saveItinerary: updateTripItinerary,
    },
    dispatch
  )
)

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/EditTrip/EventItinerary/index.js